import * as Form from '../../components/form'
import * as RasaModal from '../../components/modal'
import * as Request from '../../request'
import * as Utils from '../../utils'

export const EXPORT_SUBSCRIBERS = 'EXPORT_SUBSCRIBERS'
export const EXPORT_ASYNC_MESSAGE = 'We are exporting your contacts now.\
                                    Check your inbox for a link to download the list.'

export const FETCH_MEMBERS = 'FETCH_MEMBERS'
export const FETCH_MEMBER_COUNTS = 'FETCH_MEMBER_COUNTS'
export const FETCH_MEMBER = 'FETCH_MEMBER'
export const SORT_MEMBERS = 'SORT_MEMBERS'

export const FETCH_MEMBER_DETAILS = Utils.join(Request.SWITCH, 'FETCH_MEMBER_DETAILS')

export const ON_SEARCH = Utils.join('ON_SEARCH', 'MEMBERS')
export const ON_SEARCH_FINISHED = Utils.join(Utils.join('ON_SEARCH', 'MEMBERS'), 'FINISHED')
export const ON_EDIT = 'ON_EDIT'

export const ALL_PARTNER_CODES = 'all_partner_codes'
export const NO_PARTNER_CODES = 'no_partner_codes'

export const MemberFields = {
  Active: 'is_active',
  Created: 'created',
  Email: 'email',
  FirstName: 'first_name',
  ID: 'id',
  LastClick: 'last_click',
  LastName: 'last_name',
  LastNewsbrief: 'last_newsbrief',
  LastOpen: 'last_open',
  Name: 'last_name',
  Subscribed: 'is_subscribed',
  Updated: 'updated',
}

export const SORT_BY = {
  Asc: 'asc',
  Desc: 'desc',
}

export const PAGE_SIZE = 100
export const EXPORT_PAGE_SIZE = 3000
export const EXPORT_SOURCE = 'admin'
export const EXPORT_COUNT_EXCEEDED_MSG: string = `Max supported record count is ${EXPORT_PAGE_SIZE}.` +
  ` Apply filter to reduce the record count to fit in limit.`

export const MEMBER_IMPORT = 'MEMBER_IMPORT'
export const MEMBER_IMPORT_SERVER_RESOURCE = '/members'

export const emptyModalState: RasaModal.FileModalData = {
  file: null,
  isValid: false,
  message: '',
  name: '',
}

export const SUBSCRIBED = 'Subscribed'
export const UNSUBSCRIBED = 'Unsubscribed'
export const MEMBERS_FILTERS = 'MEMBERS_FILTERS'
export const UPDATE_MEMBER_INLINE = 'UPDATE_MEMBER_INLINE'
export const UPDATE_MEMBER = 'UPDATE_MEMBER'
export const SERVER_RESOURCE = '/members'
export const EXPORT_RESOURCE = '/export'
export const FilterFormConstants = Form.createConstantsMap(MEMBERS_FILTERS)
export const MemberFilterFormFieldNames = {
  Email: 'email',
  ModifiedSince: 'modifiedSince',
  PartnerCode: 'partner_code',
  ScheduleId: 'schedule_id',
  Status: 'state',
}
export const MEMBERS_FILTER_FORM_INITIAL_VALUES = {
  [MemberFilterFormFieldNames.Email]: '',
  [MemberFilterFormFieldNames.ModifiedSince]: '',
  [MemberFilterFormFieldNames.ScheduleId]: '',
  [MemberFilterFormFieldNames.Status]: 'All',
}



// WEBPACK FOOTER //
// ./src/pages/members/constants.ts